import { render, staticRenderFns } from "./BreadCrumbComponent.vue?vue&type=template&id=5959bf63"
import script from "./BreadCrumbComponent.vue?vue&type=script&lang=js"
export * from "./BreadCrumbComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports